const DEFAULT_ADMIN_HOSTNAME = 'perandus.neatschedule.com';
const DEFAULT_MAIN_APP_ORIGIN = 'https://neatschedule.com';
const DEFAULT_ADMIN_ORIGIN = 'https://perandus.neatschedule.com';

export const LOCAL_ADMIN_BASE_PATH = '/perandus';

const MAIN_PRODUCTION_HOSTNAMES = new Set(['neatschedule.com', 'www.neatschedule.com']);
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

export function getAdminHostname() {
  return (process.env.REACT_APP_ADMIN_HOSTNAME || DEFAULT_ADMIN_HOSTNAME).trim().toLowerCase();
}

export function getMainAppOrigin() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.trim().toLowerCase();
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return window.location.origin.replace(/\/+$/, '');
    }
  }

  const v = (process.env.REACT_APP_MAIN_APP_ORIGIN || DEFAULT_MAIN_APP_ORIGIN).trim();
  return v.replace(/\/+$/, '');
}

export function isLocalhostHostname(hostname = getCurrentHostname()) {
  return LOCAL_HOSTNAMES.has(hostname);
}

export function usesLocalAdminPath(hostname = getCurrentHostname()) {
  return isLocalhostHostname(hostname) && !isAdminHost(hostname);
}

export function getAdminBasePath() {
  return usesLocalAdminPath() ? LOCAL_ADMIN_BASE_PATH : '';
}

export function prefixAdminPath(path = '/') {
  const normalized = normalizePath(path);
  const base = getAdminBasePath();
  if (!base) return normalized;
  return normalized === '/' ? base : `${base}${normalized}`;
}

export function getAdminOrigin() {
  if (typeof window !== 'undefined' && usesLocalAdminPath()) {
    return window.location.origin.replace(/\/+$/, '');
  }

  const v = (process.env.REACT_APP_ADMIN_ORIGIN || DEFAULT_ADMIN_ORIGIN).trim();
  return v.replace(/\/+$/, '');
}

export function getCurrentHostname() {
  if (typeof window === 'undefined') return '';
  return window.location.hostname.trim().toLowerCase();
}

export function isAdminHost(hostname = getCurrentHostname()) {
  if (!hostname) return false;
  if (process.env.REACT_APP_FORCE_ADMIN_HOST === 'true') return true;
  return hostname === getAdminHostname();
}

export function isMainProductionHost(hostname = getCurrentHostname()) {
  return MAIN_PRODUCTION_HOSTNAMES.has(hostname);
}

export function shouldRedirectLegacyAdminPaths(hostname = getCurrentHostname()) {
  return isMainProductionHost(hostname) && !isAdminHost(hostname);
}

function normalizePath(path) {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
}

export function adminUrl(path = '/', { origin = getAdminOrigin() } = {}) {
  return `${origin}${prefixAdminPath(path)}`;
}

export function mainAppUrl(path = '/', { origin = getMainAppOrigin() } = {}) {
  const normalized = normalizePath(path);
  return `${origin}${normalized}`;
}

export function adminLocationHref(path = '/') {
  return adminUrl(path);
}

export function redirectToAdminUrl(path = '/', search = '', hash = '') {
  if (typeof window === 'undefined') return;
  const target = `${adminUrl(path)}${search || ''}${hash || ''}`;
  window.location.replace(target);
}
